
import { Button, Card, CardContent, FormHelperText, Grid, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { NOSPACE_REGEX, REMOVEHTML, REMOVENBSP } from "../../../utils/constants";
import EdiorJodit from "../../../components/editor/editorJodit";
import { NotificationServices } from "../../../services/AllServices";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik, Form, FormikProvider } from "formik";
import { MESSAGE } from "../../../utils/validationMessage";
import errorHandler from "../../../utils/errorHandler";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import * as Yup from "yup";


const editorContentValidation = (cmsData, context) => {
  if (cmsData === undefined || cmsData === null) {
    return context.createError({ message: "Message is required" });
  }

  const plainText = cmsData
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/gi, " ")
    .trim();

  if (!plainText) {
    return context.createError({ message: "Message is required" });
  }

  if (/^\s|^(&nbsp;)+/i.test(cmsData.replace(/<[^>]*>/g, ""))) {
    return context.createError({ message: "Message should not start with a space" });
  }

  if (plainText.length < 10) {
    return context.createError({ message: "Message must be at least 10 characters long" });
  }

  return true;
};


const validationSchema = Yup.object().shape({
  title: Yup.string()
    .required("Title is required")
    .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
    .min(2, "Please enter at least 2 characters")
    .max(100, "Title must not be more than 100 characters."),
  // message: Yup.string()
  //   .required("This field is required")
  //   .matches(NOSPACE_REGEX, MESSAGE.NO_SPACE)
  //   .min(2, "Message must be at least 2 characters")
  //   .max(1000, "Message must not be more than 1000 characters")
  //   .test("valid-body", "Message cannot be empty or contain only HTML tags", (value) => {
  //     return !!value?.replace(REMOVEHTML, "").replace(REMOVENBSP, "").trim();
  //   }),
  message: Yup.string().test(
    "custom-description-validation",
    "Message is required",
    function (value) {
      return editorContentValidation(value, this);
    }),
});

export default function EditNotification() {
  const navigate = useNavigate();
  const [cmsData, setCmsData] = useState("");
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      NotificationServices
        .getById({ id: id })
        .then((res) => {
          const data = res?.data?.data;
          formik.setValues({
            title: data.title,
            message: data.message,
            status: data.status,
          });
          setCmsData(data.message);
        })
        .catch((err) => {
          errorHandler(err);
        });
    }
  }, [id]);

  const formik = useFormik({
    initialValues: { title: "", message: "", },
    validationSchema,

    onSubmit: (values, { setSubmitting }) => {
      const apiCall = id
        ? NotificationServices.update({
          id: id,
          title: values.title,
          message: values.message,
        })
        : NotificationServices.addEmail({
          title: values.title,
          message: values.message,
        });

      apiCall
        .then((res) => {
          toast.success(res?.data?.message);
          navigate("/notification-management");
          setSubmitting(false);
        })
        .catch((err) => {
          errorHandler(err);
          setSubmitting(false);
        });
    },

  });

  const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;


  return (
    <>
      <Card>
        <CardContent>
          <FormikProvider value={formik} style={{ padding: "34px 30px" }}>
            <Typography variant="h4" sx={{ mb: 2 }} align="start">
              {id ? "Edit" : "Add"} Notification Template
            </Typography>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  name="title"
                  label="Title"
                  {...getFieldProps("title")}
                  error={Boolean(touched.title && errors.title)}
                  helperText={touched.title && errors.title}
                />

                {/* <EdiorJodit
                  data={cmsData}
                  placeholder="Message"
                  onChange={(html) => {
                    formik.setFieldTouched("message", true);
                    const withoutHtml = html.replace(REMOVEHTML, "").replace(REMOVENBSP, "").trim();

                    formik.setFieldValue("message", withoutHtml ? html : "");
                    setCmsData(html);
                  }}
                />

                {formik.touched.message && formik.errors.message && (
                  <p style={{ color: "red", fontSize: "14px" }}>
                    {formik.errors.message}
                  </p>
                )} */}

                <EdiorJodit
                  formik={formik}
                  fieldName="message"
                  onChange={(val) => formik.setFieldValue("message", val)}
                  data={formik?.values?.message}
                />
                {formik.touched.message && formik.errors.message && (
                  <FormHelperText error>
                    {formik.errors.message}
                  </FormHelperText>
                )}

              </Stack>
              <Stack
                spacing={2}
                mt={3}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Button
                  size="large"
                  type="submit"
                  variant="contained"
                  disabled={isSubmitting}
                  sx={{ my: 2 }}
                >
                  {id ? "Update" : "Add"}
                </Button>
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => {
                    if (!isSubmitting) navigate("/notification-management");
                  }}
                  sx={{ my: 2, ml: 4 }}
                >
                  Cancel
                </Button>
              </Stack>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
    </>
  );
}
